import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useUnsavedChangesPrompt(message: string, when: boolean) {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!when) return;

        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            e.returnValue = message;
            return message;
        };

        const handleNavigation = () => {
            if (!window.confirm(message)) {
                // vraća korisnika na istu stranicu ako odbije
                navigate(location.pathname, { replace: true });
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('popstate', handleNavigation);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('popstate', handleNavigation);
        };
    }, [when, message, navigate, location.pathname]);
}
